import httpClient from '@/libs/http-client'
import { normalizeSportsParams } from '@/libs/sports-request'

// 테스트용 링크
export function getGameOld (params) {
  const url = '/api/minigame/getGameOld'
  return httpClient.post(url, params).then(response => {
    return response
  })
}

export function getGame (params) {
  const url = '/api/game/getGame'
  return httpClient.post(url, normalizeSportsParams(params)).then(response => {
    return response
  })
}

export function getGameTriple (params) {
  const url = '/api/minigame/getGameTriple'
  return httpClient.post(url, params).then(response => {
    return response
  })
}

export function getGameSlotList (params, options) {
  const url = '/api/game/getGameList'
  return httpClient.post(url, normalizeSportsParams(params), options).then(response => {
    return response
  })
}

export function getSlotGame (params) {
  const url = '/api/minigame/slots/' + params.prodId + '/' + params.type
  return httpClient.post(url, params).then(response => {
    return response
  })
}

export function powerballBetting (params) {
  const url = '/api/bet/betProc'
  return httpClient.post(url, params).then(response => {
    return response
  })
}

export function powerballResult (params) {
  const url = '/api/minigame/powerballResult'
  return httpClient.post(url, params).then(response => {
    return response
  })
}
